import wfsAPIBase from "./base";

export const resourceName = "global-notifications";

export const getLatestNotification = async () => {
    return await wfsAPIBase.get(`/${resourceName}/latest`);
}